export const isSiteAdmin = (roles: string[] | undefined): boolean =>
  (roles ?? []).some((role) => {
    const normalized = role.toUpperCase();
    return (
      normalized === 'ADMIN' ||
      normalized === 'ROLE_ADMIN' ||
      normalized === 'SUPER_ADMIN' ||
      normalized === 'ROLE_SUPER_ADMIN'
    );
  });
